'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _servicesCore = require('@makerdao/services-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = function _() {};

var NullEventService = function (_LocalService) {
  (0, _inherits3.default)(NullEventService, _LocalService);

  /**
   * @param {string} name
   */
  function NullEventService() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'event';
    (0, _classCallCheck3.default)(this, NullEventService);
    return (0, _possibleConstructorReturn3.default)(this, (NullEventService.__proto__ || (0, _getPrototypeOf2.default)(NullEventService)).call(this, name));
  }

  (0, _createClass3.default)(NullEventService, [{
    key: 'on',
    value: function on() {}
  }, {
    key: 'emit',
    value: function emit() {}
  }, {
    key: 'ping',
    value: function ping() {}
  }, {
    key: 'removeListener',
    value: function removeListener() {}
  }, {
    key: 'registerPollEvents',
    value: function registerPollEvents() {}
  }, {
    key: 'buildEmitter',
    value: function buildEmitter() {
      return {
        emit: _,
        on: _,
        removeListener: _,
        registerPollEvents: _,
        ping: _,
        dispose: _
      };
    }
  }]);
  return NullEventService;
}(_servicesCore.LocalService);

exports.default = NullEventService;